import React, { useState } from 'react';
import AdminDeliveryReportTable from './AdminDeliveryReportTable';

const DUMMY_INVENTORY_DATA = {
  '411045': {
    zipcode: '411045',
    city: 'PUNE',
    products: [
      {
        name: 'Veen 660 ML Bottles',
        weeks: {
          'Jan-W1': 23, 'Jan-W2': 10, 'Jan-W3': 5, 'Jan-W4': 15,
          'Feb-W1': 12, 'Feb-W2': 8, 'Feb-W3': 18, 'Feb-W4': 7,
          'Mar-W1': 14, 'Mar-W2': 11, 'Mar-W3': 9, 'Mar-W4': 16,
          'Apr-W1': 20, 'Apr-W2': 13, 'Apr-W3': 6, 'Apr-W4': 19
        }
      },
      {
        name: '20L Glass Bottle',
        weeks: {
          'Jan-W1': 5, 'Jan-W2': 3, 'Jan-W3': 7, 'Jan-W4': 4,
          'Feb-W1': 6, 'Feb-W2': 4, 'Feb-W3': 5, 'Feb-W4': 8,
          'Mar-W1': 3, 'Mar-W2': 6, 'Mar-W3': 4, 'Mar-W4': 5,
          'Apr-W1': 7, 'Apr-W2': 5, 'Apr-W3': 3, 'Apr-W4': 6
        }
      },
      {
        name: 'Cooler Box',
        weeks: {
          'Jan-W1': 2, 'Jan-W2': 1, 'Jan-W3': 2, 'Jan-W4': 3,
          'Feb-W1': 1, 'Feb-W2': 2, 'Feb-W3': 2, 'Feb-W4': 1,
          'Mar-W1': 2, 'Mar-W2': 1, 'Mar-W3': 3, 'Mar-W4': 2,
          'Apr-W1': 3, 'Apr-W2': 2, 'Apr-W3': 1, 'Apr-W4': 2
        }
      }
    ]
  },
  '1001100': {
    zipcode: '1001100',
    city: 'MUMBAI',
    products: [
      {
        name: 'Veen 660 ML Bottles',
        weeks: {
          'Jan-W1': 35, 'Jan-W2': 28, 'Jan-W3': 22, 'Jan-W4': 31,
          'Feb-W1': 26, 'Feb-W2': 19, 'Feb-W3': 33, 'Feb-W4': 24,
          'Mar-W1': 29, 'Mar-W2': 25, 'Mar-W3': 20, 'Mar-W4': 32,
          'Apr-W1': 38, 'Apr-W2': 27, 'Apr-W3': 21, 'Apr-W4': 34
        }
      },
      {
        name: '20L Glass Bottle',
        weeks: {
          'Jan-W1': 8, 'Jan-W2': 6, 'Jan-W3': 10, 'Jan-W4': 7,
          'Feb-W1': 9, 'Feb-W2': 7, 'Feb-W3': 8, 'Feb-W4': 11,
          'Mar-W1': 6, 'Mar-W2': 9, 'Mar-W3': 7, 'Mar-W4': 8,
          'Apr-W1': 10, 'Apr-W2': 8, 'Apr-W3': 6, 'Apr-W4': 9
        }
      }
    ]
  },
  '200001': {
    zipcode: '200001',
    city: 'DELHI',
    products: [
      {
        name: 'Veen 660 ML Bottles',
        weeks: {
          'Jan-W1': 18, 'Jan-W2': 14, 'Jan-W3': 11, 'Jan-W4': 20,
          'Feb-W1': 15, 'Feb-W2': 10, 'Feb-W3': 19, 'Feb-W4': 13,
          'Mar-W1': 16, 'Mar-W2': 12, 'Mar-W3': 14, 'Mar-W4': 18,
          'Apr-W1': 21, 'Apr-W2': 15, 'Apr-W3': 10, 'Apr-W4': 22
        }
      },
      {
        name: '20L Glass Bottle',
        weeks: {
          'Jan-W1': 4, 'Jan-W2': 2, 'Jan-W3': 5, 'Jan-W4': 3,
          'Feb-W1': 3, 'Feb-W2': 4, 'Feb-W3': 2, 'Feb-W4': 5,
          'Mar-W1': 2, 'Mar-W2': 4, 'Mar-W3': 3, 'Mar-W4': 4,
          'Apr-W1': 5, 'Apr-W2': 3, 'Apr-W3': 2, 'Apr-W4': 4
        }
      },
      {
        name: 'Cooler Box',
        weeks: {
          'Jan-W1': 1, 'Jan-W2': 1, 'Jan-W3': 2, 'Jan-W4': 1,
          'Feb-W1': 1, 'Feb-W2': 1, 'Feb-W3': 1, 'Feb-W4': 2,
          'Mar-W1': 1, 'Mar-W2': 1, 'Mar-W3': 1, 'Mar-W4': 1,
          'Apr-W1': 2, 'Apr-W2': 1, 'Apr-W3': 1, 'Apr-W4': 1
        }
      }
    ]
  }
};

export default function AdminDeliveryReport() {
  const zipcodes = Object.keys(DUMMY_INVENTORY_DATA);
  const [selectedZipcode, setSelectedZipcode] = useState(zipcodes[0]);

  const currentData = DUMMY_INVENTORY_DATA[selectedZipcode];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0 }}>Delivery Reports</h3>
        <select
          value={selectedZipcode}
          onChange={(e) => setSelectedZipcode(e.target.value)}
          style={{ padding: '0.5rem', fontSize: '1rem' }}
        >
          {zipcodes.map(zip => {
            const data = DUMMY_INVENTORY_DATA[zip];
            return (
              <option key={zip} value={zip}>
                {zip} ({data.city})
              </option>
            );
          })}
        </select>
      </div>

      <div className="card shadow-sm p-3">
        <AdminDeliveryReportTable reportdata={currentData} />
      </div>
    </div>
  );
}
